<div class="step-counter">
  Step 2 of 4
</div>

<div>
  Using your
  <a href="https://ezlynxsupport.freshdesk.com/support/solutions/articles/8000094681-ezlynx-basics-login-page-two-factor-authentication#2FA-Authentication-App"
     target="2fahelp">authenticator app</a>,
  scan the QR code below:
</div>

<div class="qr-code">
  <canvas id="qr-code"></canvas>
</div>

<div class="fallback">
  Or manually enter the key below:
  <strong>{{ manualKey }}</strong>
</div>

<div class="buttons">
  <a mat-button
     href="./TypeEnrollment?verificationType=AUTHENTICATOR">Back</a>

  <a mat-flat-button
     id="btnNext"
     color="primary"
     href="./VerificationCode">Next</a>
</div>
